<template>
  <div class="header">
    <h1 class="header__heading">{{ $t("errands") }}</h1>
    <div class="header__action-block action-block row">
      <!--      <div class="action-block__securities action-block__item">-->
      <!--        <h3 class="action-block__heading">{{ $t("securities") }}</h3>-->
      <!--        <div class="row">-->
      <!--          &lt;!&ndash; TODO: убрать комопненты кнопки в стилевые компоненты, чтобы не приходилось оборачивать каждую кнопку в ссылку &ndash;&gt;-->
      <!--          <button-->
      <!--            @click="showBuyModal"-->
      <!--            class="action-block__button button filled"-->
      <!--          >-->
      <!--            {{ $t("purchase") }}-->
      <!--          </button>-->
      <!--          <button-->
      <!--            @click="showSellModal"-->
      <!--            class="action-block__button button filled"-->
      <!--          >-->
      <!--            {{ $t("sale") }}-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="action-block__repo action-block__item">-->
      <!--        <h3 class="action-block__heading">РЕПО</h3>-->
      <!--        <div class="row">-->
      <!--          <button class="action-block__button button filled">-->
      <!--            {{ $t("direct") }}-->
      <!--          </button>-->
      <!--          <button class="action-block__button button filled">-->
      <!--            {{ $t("opposite") }}-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->
      <!-- Данная функциональность еще не реализована. Элемент закоментирован перед презентацией -->
      <!-- <div class="action-block__button-select action-block__item">
        <fhs-button-select>{{ $t("errands") }} 3</fhs-button-select>
      </div> -->
    </div>
    <buy-modal :visible="isBuyModalVisible" @hideModal="hideBuyModal" />
    <sell-modal :visible="isSellModalVisible" @hideModal="hideSellModal" />
  </div>
</template>

<script>
//import ButtonSelect from "../ui-kit/ButtonSelect";

import BuyModal from "../instruction/BuyModal";
import SellModal from "../instruction/SellModal";

export default {
  components: {
    //"fhs-button-select": ButtonSelect,
    "buy-modal": BuyModal,
    "sell-modal": SellModal
  },
  data() {
    return {
      isBuyModalVisible: false,
      isSellModalVisible: false
    };
  },
  methods: {
    showBuyModal() {
      this.isBuyModalVisible = true;
    },
    hideBuyModal() {
      this.isBuyModalVisible = false;
    },
    showSellModal() {
      this.isSellModalVisible = true;
    },
    hideSellModal() {
      this.isSellModalVisible = false;
    }
  }
};
</script>

<style scoped>
.header {
  padding: 40px 0 55px 30px;
  color: #ffffff;
  background-color: #222c44;
}

.header__heading {
  margin-bottom: 0px;
  font-weight: normal;
  font-size: 36px;
}

.action-block__item:not(:first-child) {
  margin-left: 40px;
}

.action-block__heading {
  margin-bottom: 20px;
  font-size: 17px;
  font-weight: normal;
  color: #acb5c5;
}

.action-block__button {
  margin-right: 15px;
  padding: 20px 40px;
  font-size: 17px;
}

.action-block__button-select {
  display: flex;
  align-items: flex-end;
}
</style>
